<div class="content">
  <app-form-search *ngIf="showList" (search)="search($event)"></app-form-search>
  <app-back *ngIf="showBack" (backClicked)="backClicked()"></app-back>
  <app-offers-list *ngIf="showList" [paginatedResponse]="paginatedResponse" (jobOfferSelected)="jobOfferSelected($event)" (updatePageEvent)="updatePage($event)"></app-offers-list>
</div>
